import * as React from 'react';
import './Button.css';

export const Button = (props) => {
    const className = props.floating ? "button floating" : "button";
    return (
        <button className={className} onClick={props.onClick}>{props.text}</button>
    );
};